import { z } from 'zod'
import { ConfirmTwoFactorAuthenticationRequestSchema } from '~/services/api/generated'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const normalize = fieldNormalizer({ always: { trimmed: ['code'] } })

export const TwoFactorSettingsConfirm = (_context: NoContext) =>
  z.preprocess(normalize, ConfirmTwoFactorAuthenticationRequestSchema.strict())
